import { useState, useEffect } from "react";
import axiosInstance from "../../../api/axios";
import toast from "../../../shared/toast";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import MultiSelectWithCheckbox from "../../../shared/MultiSelectWithCheckbox";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Loading from "../../../shared/Loading";
import WaitLoading from "../../../shared/WaitLoading";

const NewNotification = () => {
  const navigate = useNavigate();

  const [usernameError, setUsernameError] = useState(false);
  const [loadingPlaceholder, setLoadingPlaceholder] = useState(
    "Felhasználók betöltése"
  );

  const [startDate, setStartDate] = useState(new Date());
  const [notificationType, setNotificationType] = useState(0);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [sendingLoading, setSendingLoading] = useState(false);

  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedNotiTypeOption, setSelectedNotiTypeOption] = useState(null);
  const [loading, setLoading] = useState({
    companies: false,
    notiTypes: false,
    users: false,
  });
  const [companies, setCompanies] = useState([]);
  const [notiType, setNotiType] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  useEffect(() => {
    setLoading((prev) => ({ ...prev, companies: true }));

    axiosInstance
      .get("/api-admin/companies")
      .then((response) => {
        const companyData = response.data.result;
        setCompanies(
          companyData.map((company) => ({
            value: company.id,
            label: company.name,
          }))
        );
      })
      .catch((error) => {
        console.error("Error fetching companies:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast("error", error.response.data.message);
        }
      })
      .finally(() => {
        setLoading((prev) => ({ ...prev, companies: false }));
      });

    setLoading((prev) => ({ ...prev, notiTypes: true }));

    axiosInstance
      .get("/api-admin/notifications/types")
      .then((response) => {
        const companyData = response.data.result;
        setNotiType(
          companyData.map((company) => ({
            value: company.id,
            label: company.name,
          }))
        );
      })
      .catch((error) => {
        console.error("Error fetching notification types:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast("error", error.response.data.message);
        }
      })
      .finally(() => {
        setLoading((prev) => ({ ...prev, notiTypes: false }));
      });
  }, []);

  useEffect(() => {
    handleReset();

    if (selectedOption != null) {
      setLoading((prev) => ({ ...prev, users: true })); // Felhasználók betöltésének indítása

      axiosInstance
        .get(
          `/api-admin/notifications/get-company-users/${selectedOption.value}`
        )
        .then((response) => {
          const companyData = response.data.result;
          const formattedData = companyData.map((company) => ({
            value: company.id,
            label: company.fullName + " - " + company.role,
          }));
          setUsers(formattedData);
        })
        .catch((error) => {
          console.error("Hiba a lekérdezés során:", error);
        })
        .finally(() => {
          setLoading((prev) => ({ ...prev, users: false })); // Felhasználók betöltése befejeződött
        });
    }
  }, [selectedOption]);

  useEffect(() => {
    if (loading.users) {
      const interval = setInterval(() => {
        setLoadingPlaceholder((prev) => {
          if (prev.endsWith("...")) return "Felhasználók betöltése";
          if (prev.endsWith("..")) return "Felhasználók betöltése...";
          if (prev.endsWith(".")) return "Felhasználók betöltése..";
          return "Felhasználók betöltése.";
        });
      }, 500); // 500 ms időzítés a változás között

      return () => clearInterval(interval); // Tisztítás, ha a komponens eltávolításra kerül
    } else {
      setLoadingPlaceholder("Felhasználók betöltése"); // Alaphelyzet visszaállítása
    }
  }, [loading.users]);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const handleChangeNotiType = (selectedOption) => {
    setSelectedNotiTypeOption(selectedOption);
  };

  const handleReset = () => {
    setResetTrigger(!resetTrigger);
  };

  const handleSelectionChange = (selectedValues) => {
    setSelectedCompanies(selectedValues);
  };

  const [formData, setFormData] = useState({
    email: "",
    loginCode: "",
    phoneNumber: "",
    role: "",
    message: "",
    title: "",
  });

  const { message, title } = formData;

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    if (e.target.name === "message" && e.target.value.length < 3) {
      setUsernameError(true);
    } else {
      setUsernameError(false);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSendingLoading(true);

    const userData = {
      title,
      message,
      notificationType,
      selectedUsers: selectedCompanies,
      startDate,
      companyId: selectedOption?.value,
      notificationTypeId: selectedNotiTypeOption?.value,
    };

    try {
      const response = await axiosInstance.post(
        "/api-admin/notifications",
        userData
      );
      toast("success", response.data.message);
      navigate("/notifications");

      setFormData({
        message: "",
        noti: "",
        phoneNumber: "",
        role: "",
        title: "",
      });
    } catch (error) {
      console.error("Error posting data:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast("error", error.response.data.message);
      } else {
        toast("error", "Szerver hiba");
      }
    } finally {
      setSendingLoading(false);
    }
  };

  if (sendingLoading) {
    return <WaitLoading />;
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header card-no-border pb-3">
              <h3>Új értesités létrehozása</h3>
            </div>
            {!loading.companies &&
            companies.length > 0 &&
            !loading.notiTypes &&
            notiType.length > 0 ? (
              <div className="card-body">
                <div className="horizontal-wizard-wrapper">
                  <div className="row g-3">
                    <div className="col-12">
                      <div
                        className="tab-content dark-field"
                        id="horizontal-wizard-tabContent"
                      >
                        <div
                          className="tab-pane fade show active"
                          id="wizard-info"
                          role="tabpanel"
                          aria-labelledby="wizard-info-tab"
                        >
                          <form
                            className="row g-3 needs-validation basic-form"
                            onSubmit={onSubmit}
                          >
                            <div className="col-md-5 col-xl-6">
                              <div className="card-wrapper border rounded-3 checkbox-checked">
                                <label
                                  className="form-label"
                                  htmlFor="customLastname"
                                >
                                  Értesítés típus beállítása
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="form-check-size rtl-input">
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input me-2"
                                      id="inlineRadio1"
                                      type="radio"
                                      name="inlineRadioOptions"
                                      value="0"
                                      checked={notificationType === 0}
                                      onChange={() => setNotificationType(0)}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="inlineRadio1"
                                    >
                                      Azonnali
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input me-2"
                                      id="inlineRadio2"
                                      type="radio"
                                      name="inlineRadioOptions"
                                      value="1"
                                      checked={notificationType === 1}
                                      onChange={() => setNotificationType(1)}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="inlineRadio2"
                                    >
                                      Időzített
                                    </label>
                                  </div>
                                </div>
                                {notificationType == 1 && (
                                  <div className="row pt-1">
                                    <div className="col-xl-5 col-sm-6 invalid-border-input">
                                      <label
                                        className="form-label"
                                        htmlFor="customLastname"
                                      >
                                        Küldés időpont beállítása
                                        <span className="text-danger">*</span>
                                      </label>
                                      <DatePicker
                                        selected={startDate}
                                        onChange={(date) => setStartDate(date)}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row pt-3">
                              <div className="col-xl-6 col-sm-6 invalid-border-input">
                                <label
                                  className="form-label"
                                  htmlFor="customLastname"
                                >
                                  Üzenet<span className="text-danger">*</span>
                                </label>
                                <input
                                  className="form-control"
                                  id="message"
                                  name="message"
                                  type="text"
                                  placeholder="Üzenet megadása"
                                  required=""
                                  onChange={onChange}
                                  value={message}
                                />
                              </div>
                              <div className="col-xl-4 col-sm-6 ">
                                <label
                                  className="form-label"
                                  htmlFor="customLastname"
                                >
                                  Értesítés típusa
                                  <span className="text-danger">*</span>
                                </label>

                                <Select
                                  value={selectedNotiTypeOption}
                                  onChange={handleChangeNotiType}
                                  options={notiType}
                                  className=""
                                  placeholder="Értesítés típus kiválasztása"
                                />

                                <div className="valid-feedback">
                                  Looks good!
                                </div>
                              </div>
                              <div className="col-xl-4 col-sm-6 pt-2">
                                <label
                                  className="form-label"
                                  htmlFor="customLastname"
                                >
                                  Cég hozzárendelés
                                  <span className="text-danger">*</span>
                                </label>

                                <Select
                                  value={selectedOption}
                                  onChange={handleChange}
                                  options={companies}
                                  className=""
                                  placeholder="Cég keresése"
                                />

                                <div className="valid-feedback">
                                  Looks good!
                                </div>
                              </div>
                              <div className="col-xl-4 col-sm-6 pt-2">
                                <label
                                  className="form-label"
                                  htmlFor="customLastname"
                                >
                                  Felhasználók hozzárendelése
                                  <span className="text-danger">*</span>
                                </label>
                                {!loading.users && users?.length > 0 ? (
                                  <MultiSelectWithCheckbox
                                    options={users}
                                    placeholder="Felhasználó kiválasztása"
                                    onSelectionChange={handleSelectionChange}
                                    resetTrigger={resetTrigger}
                                  />
                                ) : (
                                  <MultiSelectWithCheckbox
                                    options={users}
                                    placeholder={
                                      selectedOption == null
                                        ? "Felhasználók kiválasztása"
                                        : loading.users
                                        ? loadingPlaceholder
                                        : users.length > 0
                                        ? "Felhasználó kiválasztása"
                                        : "Nincsenek elérhető felhasználók"
                                    }
                                    onSelectionChange={handleSelectionChange}
                                    resetTrigger={resetTrigger}
                                  />
                                )}

                                <div className="valid-feedback">
                                  Looks good!
                                </div>
                              </div>
                            </div>

                            <div className="col-12 text-end">
                              <button
                                className={
                                  sendingLoading == false
                                    ? "btn btn-primary"
                                    : "btn btn-primary sending-button-disabled"
                                }
                                disabled={sendingLoading}
                              >
                                {sendingLoading == false
                                  ? "Létrehozás"
                                  : "Mentés folyamatban"}
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewNotification;
